import styled from 'styled-components'

export const Container = styled.div``

export const MenuWrapper = styled.ul`
  padding-left: 0px;
`
